import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import countryCode from './countryCode';
import events, * as fromEvents from './events';
import organisers, * as fromOrganisers from './organisers';
import appGlobalState, * as fromAppGlobalState from './appGlobalState';

const rootReducer = combineReducers({
  /**
   * Reducer for redux-connect, see https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD#reducer
   */
  reduxAsyncConnect,
  /**
   * Handles all state relating to events, details, lists, searches
   */
  events,
  /**
   * Handles all state relating to organisers, details, lists, searches
   */
  organisers,
  /**
   * Simple store of locations information
   */
  locations: (state = null) => state,
  /**
   * Simple store of country code from header
   */
  countryCode,
  /**
   * Store various global data vital for app
   */
  appGlobalState,
});

export default rootReducer;

/**
 * Selectors are used so that state shape is encapsulated within reducers
 * Components import and use these selectors rather than digging into state objects,
 * this allows state shape to change over time without modifying implementation
 */

/**
 * Events reducer
 */
// Retrieve a full event data object by ID
export const getEvent = (state, id) => fromEvents.getEvent(state.events, id);

// Retrieve full list of complete objects from an event list
export const getEventList = (state, query) => fromEvents.getList(state.events, query);

export const getEventCurrentPage = (state, query) => fromEvents.getCurrentPage(state.events, query);

// Count the number of events in a list
export const getEventListCount = (state, query) => fromEvents.getListCount(state.events, query);

// Get the details of an event list
export const getEventListDetails = (state, query) => fromEvents.getListDetails(state.events, query);

// Get the error state of an event list request
export const getEventListError = (state, query) => fromEvents.getListError(state.events, query);

// Get the fetched state of an event list
export const getEventListFetched = (state, query) => fromEvents.getListFetched(state.events, query);

// Get the fetching state of an event list request
export const getEventListFetching = (state, query) => fromEvents.getListFetching(state.events, query); // eslint-disable-line max-len

// Get the current page number of an event list
export const getEventListPage = (state, query) => fromEvents.getListPage(state.events, query);

// Retrieve the total number of events (on the server) for a list
export const getEventListTotal = (state, query) => fromEvents.getListTotal(state.events, query);

// Retrieve the total number of events (on the server) for a list, as formatted string
export const getEventListTotalFormatted = (state, query) => fromEvents.getListTotalFormatted(state.events, query); // eslint-disable-line max-len

// Get the ID of the selected event
export const getEventSelectedId = state => fromEvents.getSelectedId(state.events);

// Get the error state of the selected event request
export const getEventSelectedError = state => fromEvents.getSelectedError(state.events);

// Get the fetching state of the selected event request
export const getEventSelectedFetching = state => fromEvents.getSelectedFetching(state.events);

// Check if particular page of events is already loaded
export const checkEventPageExists = (state, query, page) => fromEvents.checkPageExists(state.events, query, page);

export const getEventCurrentPageNumber = (state, query) => fromEvents.getCurrentPageNumber(state.events, query);

export const getEventHovered = state => fromEvents.getHovered(state.events);

/**
 * Organisers reducer
 */
// Retrieve a full organiser data object by ID
export const getOrganiser = (state, id) => fromOrganisers.getOrganiser(state.organisers, id);

// Get the ID of the selected organiser
export const getOrganiserSelectedId = state => fromOrganisers.getSelectedId(state.organisers);

// Get the error state of the selected organiser request
export const getOrganiserSelectedError = state => fromOrganisers.getSelectedError(state.organisers);

// Get the fetching state of the selected organiser request
export const getOrganiserSelectedFetching = state => fromOrganisers.getSelectedFetching(state.organisers); // eslint-disable-line max-len

/**
 * App global state reducer
 */
export const getAppMapState = state => fromAppGlobalState.getMapState(state.appGlobalState);



// WEBPACK FOOTER //
// ./app/src/state/reducers/index.js